import { render, staticRenderFns } from "./ActionItem3Template.vue?vue&type=template&id=873e980e"
import script from "./ActionItem3Template.vue?vue&type=script&lang=js"
export * from "./ActionItem3Template.vue?vue&type=script&lang=js"
import style0 from "./ActionItem3Template.vue?vue&type=style&index=0&id=873e980e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports